import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAxios } from '../../Helpers/AxiosHelper';
import { useForm } from 'react-hook-form';
import { useToast } from '../../Helpers/ToastHelper';
import { classNames } from 'primereact/utils';
import { getSettings } from '../../Helpers/SettingsHelper';
import { FloatLabel, InputText, ProgressBar, SCButton, SubmitHandler, Controller } from "../../Common/Imports"
import { ApiResponse, Brands_EXT } from '../../Models/Classes';
interface BrandEditProps {
    IdBrand: number;
    OnSave?: () => void;
}

const BrandEdit: React.FC<BrandEditProps> = ({ IdBrand, OnSave }) => {
    const { t } = useTranslation();
    const { showToast } = useToast();
    const [brandData, setBrandData] = useState<Brands_EXT | undefined>();
    const {
        handleSubmit,
        formState: { errors },
        reset,
        control
    } = useForm<Brands_EXT>();
    const config = getSettings();
    const AxiosHelper = useAxios();

    useEffect(() => {
        const fetchBrand = async () => {
            try {
                const response = await AxiosHelper.get<ApiResponse<Brands_EXT>>(`Brand/Get/` + IdBrand);
                setBrandData(response.data.data);
                reset(response.data.data);
            } catch (error) {
                console.error('Error fetching user data:', error);
                showToast('error', 'Error', t("Common.Toasts.Fetch.Error"));
            }
        };
        fetchBrand();
    }, [reset, AxiosHelper, config, t, showToast, IdBrand]);

    const onSubmit: SubmitHandler<Brands_EXT> = async (data: Brands_EXT) => {
        try {
            await AxiosHelper.post<ApiResponse<Brands_EXT>>(`Brand/UpdateBrand`, data);
            showToast('success', 'Success', t("Common.Toasts.Save.Success"));
            if (OnSave) {
                OnSave();
            }
        } catch (error: unknown) {
            console.log(error);
            showToast('error', 'Error', t("Common.Toasts.Save.Error"));
        }
    };

    if (!brandData) {
        return <ProgressBar mode="indeterminate" style={{ height: '6px' }} />
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
            <div className="row mb-3 mt-3">
                <div className="col-md-6 mb-4">
                    <Controller
                        name="name"
                        control={control}
                        rules={{ required: t("Brand.Edit.Name") + " " + t("Auth.Register.Form.Required") }}
                        render={({ field }) => (
                            <FloatLabel>
                                <InputText
                                    id="Name"
                                    {...field}
                                    className={classNames({ 'p-invalid': errors.name })}
                                />
                                <label htmlFor="Name">{t("Brand.Edit.Name")}</label>
                            </FloatLabel>
                        )}
                    />
                    {errors.name && (
                        <small className="p-error">
                            {errors.name.message}
                        </small>
                    )}
                </div>
                <div className="col-md-6 mb-4">
                    <Controller
                        name="providerBrand"
                        control={control}
                        rules={{ required: t("Brand.Edit.ProviderBrand") + " " + t("Auth.Register.Form.Required") }}
                        render={({ field }) => (
                            <FloatLabel>
                                <InputText
                                    id="ProviderBrand"
                                    {...field}
                                    className={classNames({ 'p-invalid': errors.name })}
                                />
                                <label htmlFor="ProviderBrand">{t("Brand.Edit.ProviderBrand")}</label>
                            </FloatLabel>
                        )}
                    />
                    {errors.providerBrand && (
                        <small className="p-error">
                            {errors.providerBrand.message}
                        </small>
                    )}
                </div>
                <div className="col-md-6 mb-4">
                    <Controller
                        name="emails"
                        control={control}
                        rules={{ required: t("Brand.Edit.Email") + " " + t("Auth.Register.Form.Required") }}
                        render={({ field }) => (
                            <FloatLabel>
                                <InputText
                                    id="Email"
                                    {...field}
                                    className={classNames({ 'p-invalid': errors.name })}
                                />
                                <label htmlFor="Email">{t("Brand.Edit.Email")}</label>
                            </FloatLabel>
                        )}
                    />
                    {errors.emails && (
                        <small className="p-error">
                            {errors.emails.message}
                        </small>
                    )}
                </div>
                <div className="col-md-6 mb-4">
                    <Controller
                        name="phone"
                        control={control}
                        rules={{ required: t("Brand.Edit.Phone") + " " + t("Auth.Register.Form.Required") }}
                        render={({ field }) => (
                            <FloatLabel>
                                <InputText
                                    id="Email"
                                    {...field}
                                    className={classNames({ 'p-invalid': errors.name })}
                                />
                                <label htmlFor="Phone">{t("Brand.Edit.Phone")}</label>
                            </FloatLabel>
                        )}
                    />
                    {errors.phone && (
                        <small className="p-error">
                            {errors.phone.message}
                        </small>
                    )}
                </div>
                <div className="col-md-12 mb-4">
                    <Controller
                        name="logo"
                        control={control}
                        rules={{ required: t("Brand.Edit.Logo") + " " + t("Auth.Register.Form.Required") }}
                        render={({ field }) => (
                            <FloatLabel>
                                <InputText
                                    id="Logo"
                                    {...field}
                                    className={classNames({ 'p-invalid': errors.name })}
                                />
                                <label htmlFor="Logo">{t("Brand.Edit.Logo")}</label>
                            </FloatLabel>
                        )}
                    />
                    {errors.phone && (
                        <small className="p-error">
                            {errors.phone.message}
                        </small>
                    )}
                </div>
                <div className="row">
                    <div className="col">
                        <SCButton Type="submit" Label={t("Common.Buttons.Save")} Name="Save" />
                    </div>
                </div>
            </div>
        </form>
    );
};

export default BrandEdit;
